import React, { useMemo, useState } from "react";
import axios from "axios";
import {
  Box,
  Card,
  Container,
  Stack,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import LoadingButton from "@mui/lab/LoadingButton";
import { API_BASE_URL } from "../../constants/apiConstants";
import provincias from "../../constants/provincias";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import { useTheme } from "@mui/system";
import Tooltip from "@mui/material/Tooltip";
import { SecondStepSchema } from "./schemas/SecondStepSchema";
import { getInitialValuesSecondStep } from "./initialValues/InitialValuesSecondStep";
import { FirstStepSchema } from "./schemas/FirstStepSchema";
import { initialValuesFirstStep } from "./initialValues/initialValuesFirstStep";
import { UploadedFileItem } from "./components/UploadFileItem";
import { TermsAndConditionsModal } from "../../components/doctor/TermsAndConditionsModal";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";

const CustomInputLabel = styled(InputLabel)(({ theme }) => ({
  "&.MuiInputLabel-outlined.MuiInputLabel-shrink": {
    backgroundColor: "white",
  },
}));

const Register = () => {
  const theme = useTheme();

  const [loading, setLoading] = useState(false);

  const [form1ErrorMessage, setForm1ErrorMessage] = useState("");
  const [form2ErrorMessage, setForm2ErrorMessage] = useState("");

  const [validation, setValidation] = useState(true);
  const [registration, setRegistration] = useState(false);
  const [accountCreated, setAccountCreated] = useState(false);

  const [openModal, setOpenModal] = React.useState(false);

  const [values, setValues] = React.useState({
    showPassword: false,
    showRePassword: false,
  });

  const handleCheckboxChange = () => {
    const checked = formik02.getFieldProps("terminosCondiciones").value;

    if (!checked) {
      formik02.setFieldValue("terminosCondiciones", true);
    } else {
      formik02.setFieldValue("terminosCondiciones", false);
    }
  };

  const handleOpenModalTermsAndConditions = () => {
    setOpenModal(true);
  };

  const handleCloseModalTermsAndConditions = () => {
    setOpenModal(false);
  };
  // Función para manejar el cambio en el campo de fecha de nacimiento
  const handleChangeNacimiento = (event) => {
    const { name, value } = event.target;
    formik02.setValues({
      ...formik02.values,
      [name]: value,
    });
  };

  /* FILES */
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChangeNew = (e) => {
    setForm2ErrorMessage("");

    const maxFiles = 3; // Límite de archivos
    let isValid = true;
    const files = e.target.files;

    // Verifica la cantidad actual de archivos seleccionados
    if (selectedFiles.length + files.length > maxFiles) {
      isValid = false;
      console.error("Se ha alcanzado el límite de 3 documentos.");
      setForm2ErrorMessage("Se ha alcanzado el límite de 3 documentos.");
    } else {
      const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];

      for (let i = 0; i < files.length; i++) {
        const fileName = files[i].name;
        const fileSize = files[i].size;
        const fileExtension = fileName.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
          isValid = false;
          console.error(
            `El archivo ${fileName} tiene un formato no permitido.`
          );
          setForm2ErrorMessage(
            `El archivo ${fileName} tiene un formato no permitido. Seleccione otro archivo.`
          );
          break; // Puedes detener la verificación en caso de que un archivo sea inválido
        }

        if (fileSize > 2000000) {
          isValid = false;
          setForm2ErrorMessage(
            `El archivo ${fileName} supera los 2MB. Seleccione otro archivo.`
          );
          break; // Puedes detener la verificación en caso de que un archivo sea inválido
        }
      }
    }

    if (isValid) {
      // Agrega solo los archivos que no excedan el límite
      const newFiles = [...selectedFiles, ...files].slice(0, maxFiles);
      setSelectedFiles(newFiles);
    }
  };

  const handleFilesReset = () => {
    setSelectedFiles([]);
  };

  const removeFile = (fileToRemove) => {
    const newSelectedFiles = selectedFiles.filter(
      (file) => file.name !== fileToRemove.name
    );
    setSelectedFiles(newSelectedFiles);
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const formik01 = useFormik({
    initialValues: initialValuesFirstStep,
    validationSchema: FirstStepSchema,
    onSubmit: (values) => {
      handleValidation();
    },
  });

  const formik02 = useFormik({
    initialValues: getInitialValuesSecondStep(formik01),
    validationSchema: SecondStepSchema,
    onSubmit: (values) => {
      handleRegister();
    },
  });

  const form1Values = formik01.values;
  const form2Values = formik02.values;

  const form1Errors = formik01.errors;
  const form2Errors = formik02.errors;

  const form1Touched = formik01.touched;
  const form2Touched = formik02.touched;

  const handleForm1Change = formik01.handleChange;
  const handleForm2Change = formik02.handleChange;

  const handleForm1TipoMatriculaChange = (e) => {
    const selectedTipoMatricula = e.target.value;
    formik01.setFieldValue("tipoMatricula", selectedTipoMatricula);
    if (selectedTipoMatricula === "MN") {
      formik01.setFieldValue("provincia", "CIUDAD AUTONOMA DE BS AS");
      setProvinciaSISAandRecipe([
        {
          nombre: "CIUDAD AUTONOMA DE BS AS",
          sisa: "CABA",
          recipe: "CIUDAD AUTONOMA DE BS AS",
        },
      ]);
    } else {
      formik01.setFieldValue("provincia", "");
      setProvinciaSISAandRecipe([]);
    }
    formik01.handleChange(e);
  };

  const handleForm1ProvinciaChange = (e) => {
    const selectedProvincia = e.target.value;
    formik01.setFieldValue("provincia", selectedProvincia);

    if (selectedProvincia !== "CIUDAD AUTONOMA DE BS AS") {
      formik01.setFieldValue("tipoMatricula", "MP");
    } else {
      formik01.setFieldValue("tipoMatricula", "MN");
    }

    // Encontrar la provincia seleccionada en el array
    const province = provincias.find(
      (prov) => prov.recipe === selectedProvincia
    );
    if (province) {
      setProvinciaSISAandRecipe([
        {
          sisa: province.sisa,
          recipe: province.recipe,
        },
      ]);
    } else {
      setProvinciaSISAandRecipe([
        {
          SISA: "",
          recipe: "",
        },
      ]);
    }

    formik01.handleChange(e);
  };

  const handleForm1Blur = formik01.handleBlur;
  const handleForm2Blur = formik02.handleBlur;

  const handleForm1Submit = formik01.handleSubmit;
  const handleForm2Submit = formik02.handleSubmit;

  const [dni, setDni] = useState("");
  const [tipoMatricula, setTipoMatricula] = useState("");
  const [nroMatricula, setNroMatricula] = useState("");
  const [provincia, setProvincia] = useState("");
  const [provinciaSISAandRecipe, setProvinciaSISAandRecipe] = useState([]);

  const handleChangeDni = (event) => {
    setDni(event.target.value);
  };

  const handleChangeNroMatricula = (event) => {
    setNroMatricula(event.target.value);
  };

  const disableRegisterButton = useMemo(() => {
    return Object.keys(form2Errors).length > 0 || selectedFiles.length === 0;
  }, [form2Errors, selectedFiles.length]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    formik02.setValues({
      ...formik02.values,
      [name]: value,
    });
  };

  const handleGoBack = () => {
    setValidation(!validation);
    setRegistration(!registration);
    setForm1ErrorMessage("");
  };

  const handleValidation = async () => {
    setLoading(true);
    const province = provincias.find(
      (prov) => prov.recipe === formik01.values.provincia
    );

    const validation = await getValidation(
      formik01.values.dni,
      formik01.values.nroMatricula,
      province.sisa
    );

    if (validation && validation.status === "Ok") {
      formik02.setValues({
        ...formik02.values,
        dni: formik01.values.dni,
        tipoMatricula: formik01.values.tipoMatricula,
        nroMatricula: formik01.values.nroMatricula,
        provincia: formik01.values.provincia,
      });

      setValidation(!validation);
      setRegistration(!registration);
      setForm1ErrorMessage("");
    } else {
      setForm1ErrorMessage(validation.errors.join());
    }
    setLoading(false);
  };

  const getValidation = async (dni, nroMatricula, provincia) => {
    try {
      const tokenUrl = `${API_BASE_URL}Medicos/ValidaMedico/Token`;
      const tokenResponse = await axios.get(tokenUrl);
      const validaToken = tokenResponse?.data?.token;

      if (!validaToken) {
        throw new Error("No se pudo obtener el token de validación.");
      }

      const url = `${API_BASE_URL}Medicos/ValidaMedico`;
      const response = await axios.post(url, {
          dni: dni,
          nroMatricula: nroMatricula,
          provincia: provincia,
        },
        {
          headers: {
            "X-Valida-Token": validaToken,
          },
        }
      );
      if (response.data.result !== null) {
        const { data } = response;
        form2Values.nombre = data.result.nombre;
        form2Values.apellido = data.result.apellido;
      }
      return response.data;
    } catch (error) {
      setForm1ErrorMessage(error);
    }
  };

  const postRegistraMedico = async (values, files) => {
    try {
      const url = `${API_BASE_URL}Medicos/RegistraMedico`;
      const provinceData = provincias.find(
        (prov) => prov.recipe === values.provincia
      );

      if (!provinceData) {
        throw new Error("Provincia no encontrada");
      }

      const data = {
        nombre: values.nombre,
        apellido: values.apellido,
        DNI: values.dni,
        tipoMatricula: values.tipoMatricula,
        nroMatricula: values.nroMatricula,
        provinciaMatricula: provinceData.recipe,
        provinciaSISA: provinceData.sisa,
        telefono: values.telefono,
        especialidad: values.especialidad,
        fechaNacimiento: values.nacimiento,
        sexo: values.sexo,
        direccionConsultorio: values.direccion,
        email: values.email,
        password: values.password,
        aceptaTerminos: values.terminosCondiciones,
        pais: "Argentina",
      };

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });

      files.forEach((file) => {
        formData.append("documentacion", file);
      });

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      setForm2ErrorMessage(error);
    }
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleClickShowRePassword = () => {
    setValues({
      ...values,
      showRePassword: !values.showRePassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleRegister = async () => {
    if (selectedFiles.length === 0) {
      setForm2ErrorMessage(
        "Debe adjuntar imagen de DNI (frente y dorso) y matrícula para poder registrar su usuario"
      );
      return;
    }

    setLoading(true);
    const newValues = { ...form1Values, ...form2Values };
    const register = await postRegistraMedico(newValues, selectedFiles);

    if (register && register.status === "Ok") {
      setRegistration(!registration);
      setAccountCreated(!accountCreated);
      setForm2ErrorMessage("");
    } else {
      setForm2ErrorMessage(register.errors.join());
    }
    setLoading(false);
  };

  const disableDoctorValidationButton = useMemo(() => {
    return (
      !form1Values.dni ||
      !form1Values.nroMatricula ||
      !form1Values.provincia ||
      !form1Values.tipoMatricula
    );
  }, [
    form1Values.dni,
    form1Values.nroMatricula,
    form1Values.provincia,
    form1Values.tipoMatricula,
  ]);

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        marginTop: 20,
      }}
    >
      <Container maxWidth="sm">
        <Card sx={{ padding: "20px" }}>
          {/* Registración - Step 1 */}
          {validation && (
            <form onSubmit={handleForm1Submit}>
              <Box sx={{ my: 1 }}>
                <Typography color="textPrimary" align="center" variant="h4">
                  Registro de Médico
                </Typography>
              </Box>
              <Box
                sx={{
                  pb: 1,
                  pt: 1,
                  mb: 4,
                }}
              >
                <Typography
                  align="center"
                  color="textSecondary"
                  variant="body1"
                >
                  Complete los datos para registrarse como usuario
                </Typography>
              </Box>
              <Typography
                align="left"
                color="textSecondary"
                variant="subtitle2"
                sx={{ mb: 2 }}
              >
                Los campos con * son requeridos
              </Typography>
              <TextField
                fullWidth
                label="DNI *"
                name="dni"
                onChange={handleForm1Change}
                onBlur={handleForm1Blur}
                value={form1Values.dni}
                type="text"
                variant="outlined"
                error={Boolean(form1Touched.dni && form1Errors.dni)}
                helperText={form1Touched.dni && form1Errors.dni}
              />
              <Box sx={{ my: 2, marginBottom: 2 }}>
                <TextField
                  error={Boolean(
                    form1Touched.provincia && form1Errors.provincia
                  )}
                  fullWidth
                  helperText={form1Touched.provincia && form1Errors.provincia}
                  label="Tipo de Matricula *"
                  name="tipoMatricula"
                  select
                  onBlur={handleForm1Blur}
                  onChange={handleForm1TipoMatriculaChange}
                  value={form1Values.tipoMatricula}
                  variant="outlined"
                >
                  <MenuItem value="" disabled>
                    Selecciona una opción...
                  </MenuItem>
                  <MenuItem value="MN">Matrícula Nacional</MenuItem>
                  <MenuItem value="MP">Matrícula Provincial</MenuItem>
                </TextField>
              </Box>
              <Box sx={{ my: 2, marginBottom: 2 }}>
                <TextField
                  error={Boolean(
                    form1Touched.provincia && form1Errors.provincia
                  )}
                  fullWidth
                  helperText={form1Touched.provincia && form1Errors.provincia}
                  label="Provincia *"
                  name="provincia"
                  select
                  onBlur={handleForm1Blur}
                  onChange={handleForm1ProvinciaChange}
                  value={form1Values.provincia}
                  variant="outlined"
                >
                  <MenuItem value="" disabled>
                    Selecciona una opción...
                  </MenuItem>
                  {provincias.map((option) => (
                    <MenuItem key={option.sisa} value={option.recipe}>
                      {option.sisa}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
              <TextField
                fullWidth
                label="Nro de Matrícula *"
                name="nroMatricula"
                type="text"
                onChange={handleForm1Change}
                onBlur={handleForm1Blur}
                value={form1Values.nroMatricula}
                variant="outlined"
                error={Boolean(
                  form1Touched.nroMatricula && form1Errors.nroMatricula
                )}
                helperText={
                  form1Touched.nroMatricula && form1Errors.nroMatricula
                }
              />

              {form1ErrorMessage && (
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "400",
                    textAlign: "center",
                    color: "red",
                    mt: 2,
                  }}
                >
                  {form1ErrorMessage}
                </Typography>
              )}

              <Box sx={{ py: 2 }}>
                <LoadingButton
                  loading={loading}
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  disabled={Boolean(disableDoctorValidationButton)}
                >
                  Validar médico
                </LoadingButton>
              </Box>
              <Typography align="center" variant="body2" color="textSecondary">
                1 / 2
              </Typography>
            </form>
          )}

          {/* Registración - Step 2 */}
          {registration && (
            <form onSubmit={handleForm2Submit}>
              <Box sx={{ my: 1 }}>
                <Typography color="textPrimary" align="center" variant="h4">
                  Registro de Médico
                </Typography>
              </Box>
              <Box
                sx={{
                  pb: 1,
                  pt: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 4,
                }}
              >
                <IconButton
                  color="primary"
                  onClick={handleGoBack}
                  sx={{ borderRadius: "50%" }}
                >
                  <ArrowBackIosNewOutlinedIcon />
                </IconButton>
                <Typography
                  align="center"
                  color="textSecondary"
                  variant="body1"
                  sx={{ marginLeft: 1, flexGrow: 1 }}
                >
                  Complete los datos para registrarse como usuario
                </Typography>
              </Box>
              <Typography
                align="left"
                color="textSecondary"
                variant="subtitle2"
                sx={{ mt: 2, mb: 2 }}
              >
                Los campos con * son requeridos
              </Typography>
              <TextField
                fullWidth
                label="Nombre *"
                margin="normal"
                name="nombre"
                type="text"
                variant="outlined"
                onChange={handleForm2Change}
                onBlur={handleForm2Blur}
                value={form2Values.nombre}
                error={Boolean(form2Touched.nombre && form2Errors.nombre)}
                helperText={form2Touched.nombre && form2Errors.nombre}
                sx={{ my: 1 }}
                disabled={!validation}
              />
              <TextField
                fullWidth
                label="Apellido *"
                margin="normal"
                name="apellido"
                type="text"
                variant="outlined"
                onChange={handleForm2Change}
                onBlur={handleForm2Blur}
                value={form2Values.apellido}
                error={Boolean(form2Touched.apellido && form2Errors.apellido)}
                helperText={form2Touched.apellido && form2Errors.apellido}
                sx={{ my: 1 }}
                disabled={!validation}
              />
              <TextField
                fullWidth
                label="DNI"
                margin="normal"
                name="dni"
                onChange={handleChangeDni}
                value={form2Values.dni}
                type="text"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                sx={{ my: 1 }}
                disabled={!validation}
              />
              <Box>
                <FormControl fullWidth variant="outlined" sx={{ my: 1 }}>
                  <TextField
                    fullWidth
                    label="Tipo Matrícula"
                    margin="normal"
                    name="tipoMatricula"
                    onChange={undefined}
                    value={
                      form2Values.tipoMatricula === "MN"
                        ? "Matrícula Nacional"
                        : "Matrícula Provincial"
                    }
                    type="text"
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                    sx={{ my: 1 }}
                    disabled={!validation}
                  />
                </FormControl>
              </Box>
              <Box>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    fullWidth
                    label="Provincia"
                    margin="normal"
                    name="provincia"
                    onChange={undefined}
                    value={provinciaSISAandRecipe[0].sisa}
                    type="text"
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                    disabled={!validation}
                  />
                </FormControl>
              </Box>
              <TextField
                fullWidth
                label="Nro de Matrícula"
                margin="normal"
                name="nroMatricula"
                onChange={handleChangeNroMatricula}
                type="text"
                value={form2Values.nroMatricula}
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                disabled={!validation}
              />
              <TextField
                fullWidth
                label="Teléfono *"
                margin="normal"
                name="telefono"
                type="text"
                variant="outlined"
                onChange={handleForm2Change}
                onBlur={handleForm2Blur}
                value={form2Values.telefono}
                error={Boolean(form2Touched.telefono && form2Errors.telefono)}
                helperText={form2Touched.telefono && form2Errors.telefono}
              />
              <TextField
                fullWidth
                label="Especialidad*"
                margin="normal"
                name="especialidad"
                type="text"
                variant="outlined"
                onChange={handleForm2Change}
                onBlur={handleForm2Blur}
                value={form2Values.especialidad}
                error={Boolean(
                  form2Touched.especialidad && form2Errors.especialidad
                )}
                helperText={
                  form2Touched.especialidad && form2Errors.especialidad
                }
                sx={{ mb: 1, mt: 2 }}
              />
              <TextField
                fullWidth
                label={
                  form2Values.nacimiento
                    ? "Fecha de nacimiento"
                    : "Selecciona una fecha"
                }
                margin="normal"
                name="nacimiento"
                type="date"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeNacimiento}
                onBlur={handleForm2Blur}
                value={form2Values.nacimiento}
                error={Boolean(
                  form2Touched.nacimiento && form2Errors.nacimiento
                )}
                helperText={form2Touched.nacimiento && form2Errors.nacimiento}
                sx={{ mb: 3, mt: 2 }}
              />
              <Box sx={{ mb: 2 }}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={Boolean(form2Touched.sexo && form2Errors.sexo)}
                >
                  <CustomInputLabel shrink htmlFor="sexo">
                    Sexo *
                  </CustomInputLabel>
                  <Select
                    native
                    onChange={handleChange}
                    onBlur={handleForm2Blur}
                    value={form2Values.sexo}
                    label="Sexo *"
                    inputProps={{
                      name: "sexo",
                      id: "sexo",
                    }}
                    error={Boolean(form2Touched.sexo && form2Errors.sexo)}
                  >
                    <option value="" disabled>
                      Selecciona una opción...
                    </option>
                    <option value="F">FEMENINO</option>
                    <option value="M">MASCULINO</option>
                    <option value="X">OTRO</option>
                  </Select>
                  {form2Touched.sexo && form2Errors.sexo && (
                    <Typography
                      color="error"
                      variant="body2"
                      sx={{ fontSize: "0.8rem", ml: 1.5, mt: 0.5 }}
                    >
                      {form2Errors.sexo}
                    </Typography>
                  )}
                </FormControl>
              </Box>

              <TextField
                fullWidth
                label="Dirección del consultorio*"
                margin="normal"
                name="direccion"
                type="text"
                variant="outlined"
                onChange={handleForm2Change}
                onBlur={handleForm2Blur}
                value={form2Values.direccion}
                error={Boolean(form2Touched.direccion && form2Errors.direccion)}
                helperText={form2Touched.direccion && form2Errors.direccion}
                sx={{ my: 1, mb: 2 }}
              />

              <TextField
                fullWidth
                label="Email (usuario) *"
                margin="normal"
                name="email"
                type="email"
                variant="outlined"
                autoComplete="new-email"
                onChange={handleForm2Change}
                onBlur={handleForm2Blur}
                value={form2Values.email}
                error={Boolean(form2Touched.email && form2Errors.email)}
                helperText={form2Touched.email && form2Errors.email}
                sx={{ my: 1 }}
              />
              <TextField
                error={Boolean(form2Touched.password && form2Errors.password)}
                fullWidth
                helperText={form2Touched.password && form2Errors.password}
                label="Contraseña"
                margin="normal"
                name="password"
                onBlur={handleForm2Blur}
                onChange={handleForm2Change}
                type={values.showPassword ? "text" : "password"}
                value={form2Values.password}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                error={Boolean(
                  form2Touched.repassword && form2Errors.repassword
                )}
                fullWidth
                helperText={form2Touched.repassword && form2Errors.repassword}
                label="Verificación de contraseña"
                margin="normal"
                name="repassword"
                onBlur={handleForm2Blur}
                onChange={handleForm2Change}
                type={values.showRePassword ? "text" : "password"}
                value={form2Values.repassword}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowRePassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showRePassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {/* CHECKBOX */}
              <Box sx={{ display: "flex", alignItems: "center", my: 1 }}>
                <Checkbox
                  checked={form2Values.terminosCondiciones}
                  onChange={handleCheckboxChange}
                  color="primary"
                />
                <Button onClick={handleOpenModalTermsAndConditions}>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ fontWeight: 600 }}
                  >
                    Acepto los términos y condiciones
                  </Typography>
                </Button>
              </Box>
              {form2Touched.terminosCondiciones &&
                form2Errors.terminosCondiciones && (
                  <FormHelperText error>
                    {form2Errors.terminosCondiciones}
                  </FormHelperText>
                )}

              {/* MODAL */}
              <TermsAndConditionsModal
                openModal={openModal}
                onClose={handleCloseModalTermsAndConditions}
              />

              {/* Agrega campos para cargar archivos */}
              <Box
                sx={{
                  py: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  component="label"
                  variant="contained"
                  onChange={handleFileChangeNew}
                  multiple
                  startIcon={<CloudUploadIcon />}
                >
                  Subir documentos
                  <VisuallyHiddenInput
                    type="file"
                    accept=".jpg, .jpeg, .png, .pdf"
                  />
                </Button>

                <Tooltip title="Elimina todos los archivos seleccionados.">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleFilesReset}
                    sx={{
                      borderRadius: "50%", // Hace que el botón sea completamente redondo
                      minWidth: 0, // Permite que el botón sea más pequeño que el contenido mínimo
                      padding: 0, // Elimina el relleno para que el botón sea más compacto
                      width: "36px", // Establece el ancho deseado
                      height: "36px", // Establece la altura deseada
                    }}
                    loadingPosition="start"
                  >
                    <DeleteForeverOutlinedIcon />
                  </Button>
                </Tooltip>
              </Box>
              <Box sx={{ paddingBottom: 2 }}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontWeight: 600 }}
                >
                  Debe subir el frente y contrafrente del DNI junto con el
                  título respaldatorio del médico.
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontWeight: 300 }}
                >
                  *Mínimo 1, máximo 3 archivos.
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontWeight: 300 }}
                >
                  *Las extensiones permitidas son: jpg, jpeg, png, pdf.
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontWeight: 300 }}
                >
                  *Los archivos no pueden exceder los 2 MB.
                </Typography>
              </Box>

              {selectedFiles.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p>Archivos cargados:</p>
                  <Box>
                    <Stack spacing={1}>
                      {selectedFiles.map((file) => (
                        <UploadedFileItem
                          key={file.name}
                          fileName={file.name}
                          onClickDeleteButton={() => removeFile(file)}
                        />
                      ))}
                    </Stack>
                  </Box>
                </Box>
              )}

              {/* Mostrar el mensaje de error de Formik para documentos */}
              {form2Touched.documentos && form2Errors.documentos && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{ fontSize: "0.8rem", mt: 0.5 }}
                >
                  {form2Errors.documentos}
                </Typography>
              )}

              {form2ErrorMessage && (
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "400",
                    textAlign: "center",
                    color: theme.palette.error.main,
                  }}
                >
                  {form2ErrorMessage}
                </Typography>
              )}
              <Box sx={{ py: 2 }}>
                <LoadingButton
                  loading={loading}
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  disabled={disableRegisterButton}
                >
                  Registrar médico
                </LoadingButton>
              </Box>
              <Typography align="center" variant="body2" color="textSecondary">
                2 / 2
              </Typography>
            </form>
          )}

          {/* Cuenta Creada */}
          {accountCreated && (
            <form>
              <Box sx={{ my: 1 }}>
                <Typography color="textPrimary" align="center" variant="h4">
                  Registro exitoso
                </Typography>
              </Box>
              <Box
                sx={{
                  pb: 1,
                  pt: 1,
                }}
              >
                <Typography
                  align="center"
                  color="textSecondary"
                  variant="body1"
                >
                  Recibirá un mail al correo electrónico registrado para que
                  active su cuenta. Si no ha recibido el email en los próximos
                  minutos, por favor verifique en la bandeja de SPAM.
                </Typography>
              </Box>
            </form>
          )}
        </Card>
      </Container>
    </Box>
  );
};

export default Register;
